import { Resources } from "./Resources";

export const TeachersResources = () => {
  return (
    <Resources blog_type="staff" />
  );
};
